import React, { VFC } from 'react';
import { IIconProps } from './types';

const PackagePlusIcon: VFC<IIconProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 16.8v-5.6c0-.246-.062-.487-.179-.7a1.369 1.369 0 0 0-.488-.512l-4.666-2.8a1.285 1.285 0 0 0-1.334 0l-4.666 2.8c-.203.123-.371.3-.488.512a1.455 1.455 0 0 0-.179.7v5.6c0 .246.062.487.179.7.117.212.285.389.488.512l4.666 2.8a1.285 1.285 0 0 0 1.334 0l4.666-2.8c.203-.123.371-.3.488-.512.117-.213.179-.454.179-.7Z"
      stroke={color}
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="m2 11 6 3 6-3"
      stroke={color}
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M8 21v-7"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 14a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm0-9.938a1 1 0 0 1 1 1V6.5h1.438a1 1 0 1 1 0 2H18.5v1.438a1 1 0 1 1-2 0V8.5h-1.438a1 1 0 1 1 0-2H16.5V5.062a1 1 0 0 1 1-1Z"
      fill="#fff"
    />
  </svg>
);

export default PackagePlusIcon;
